import getNormalizedAmountFromCents from './get-normalized-amount-from-cents';

const getPriceTagFromAmount = (amount: number) => {
  const isAmountNegative = amount < 0;

  return `R$ ${isAmountNegative ? '-' : ''}${getNormalizedAmountFromCents(Math.abs(amount))}`;
};

export default getPriceTagFromAmount;
